import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { AlertService } from '../../../services/alert/alert.service';
import { LoadingService } from '../../../services/loading/loading.service';
import { BaseMaintenanceController } from '../_base/BaseMaintenanceController';
import { NoticeItemMaintenanceDto } from './NoticeItemMaintenanceDto';
import { NoticeListMaintenanceDto } from './NoticeListMaintenanceDto';

@Injectable()
export class NoticeMaintenanceController extends
    BaseMaintenanceController<NoticeListMaintenanceDto, NoticeItemMaintenanceDto> {

    constructor(
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router) {

        super(http, alertService, translateService, loadingService, router, 'notice');
    }

    public getResourceRoot(): string {
        return 'NOTICE';
    }

    public buildUrl(uri: string): string {
        return '/internal/notice' + uri;
    }
}
